import type { SxProps } from '../../themes/themes';

export const getStyles = (): { [key: string]: SxProps } => {
  return {
    figure: {
      margin: 0,
      padding: 0,
      display: 'inherit',
    },
    figureAlignment: {
      left: {
        display: 'grid',
        justifyContent: 'left',
      },
      right: {
        display: 'grid',
        justifyContent: 'right',
      },
      center: {
        display: 'grid',
        justifyContent: 'center',
      },
    },
  };
};
